module.exports = __webpack_public_path__ + "static/media/file-exclamation.bb7ba37d.svg";